import { render, staticRenderFns } from "./AccessibilitySubCategories.vue?vue&type=template&id=cf4f72f6"
import script from "./AccessibilitySubCategories.vue?vue&type=script&lang=js"
export * from "./AccessibilitySubCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports